import type { ExpenseClaimStatus } from '@/types/mobility';

export type ClaimStatusColor = 'default' | 'info' | 'warning' | 'success' | 'error';

/**
 * Maps an expense claim status to the MUI color used to render it (e.g. as a chip).
 *
 * @param status - The claim's current status.
 * @returns The corresponding {@link ClaimStatusColor}; `'default'` for statuses with no special color.
 */
export function getClaimStatusColor(status: ExpenseClaimStatus): ClaimStatusColor {
  if (status === 'Submitted') return 'warning';
  if (status === 'UnderReview') return 'info';
  if (status === 'Approved' || status === 'PayrollReady' || status === 'Processed') return 'success';
  if (status === 'Rejected') return 'error';
  return 'default';
}
